import React from "react";
import Heroicon from "../Heroicon";

function SlugMessage({ slugValidation, value, className }) {
  return (
    <div className={className}>
      {slugValidation === "error" ? (
        <p className="flex items-center mt-2 text-sm text-red-600">
          <Heroicon icon="o-exclamation-circle" style="w-5 h-5 mr-1" />
          The sub-domain cannot end with a dash.
        </p>
      ) : (
        <>
          {slugValidation === "unavailable" &&
            slugValidation !== null &&
            value && (
              <p className="flex items-center text-sm text-red-600">
                <Heroicon icon="o-exclamation-circle" style="w-5 h-5 mr-1" />
                This sub-domain is already taken. Modify it to continue.
              </p>
            )}
          {slugValidation === "available" &&
            slugValidation !== null &&
            value && (
              <p className="flex items-center text-sm text-green-600">
                <Heroicon icon="o-check-circle" style="w-5 h-5 mr-1" />
                This sub-domain is available!
              </p>
            )}
          {slugValidation === null && value && (
            <p className="flex items-center text-sm text-blue-600">
              <Heroicon icon="o-arrow-path" style="w-5 h-5 mr-1 animate-spin" />
              Checking availability...
            </p>
          )}
        </>
      )}
    </div>
  );
}

export default SlugMessage;
